import { PriceCheck } from '@mui/icons-material';
import Page from 'components/new/Page';
import ErrorBoundary from 'components/ErrorBoundary';
import TabsPanel from 'further-ui/components/TabsPanel';
import PageLoader from 'components/PageLoader';

import ChartOfAccounts from './ChartOfAccounts';
import FundSetup from './FundSetup';
import AccountMapping from './AccountMapping';
import FeeSettings from './FeeSettings';
import CarrySettings from './CarrySettings';
import EqualisationInterest from './EqualisationInterest';

const tabs = [
  {
    key: 'general',
    label: 'General',
    content: <FundSetup />,
    urlParam: 'general',
  },
  /*
  Uncoment when features are ready
  {
    key: 'approvalFlows',
    label: 'Approval Flows',
    content: <ApprovalFlows />,
    urlParam: 'approvalFlows',
  },
  */
  {
    key: 'chartOfAccounts',
    label: 'Chart of accounts',
    content: <ChartOfAccounts />,
    urlParam: 'chartOfAccounts',
  },
  {
    key: 'accountMapping',
    label: 'Account mapping',
    content: <AccountMapping />,
    urlParam: 'accountMapping',
  },
  {
    key: 'feeSettings',
    label: 'Fee settings',
    content: <FeeSettings />,
    urlParam: 'feeSettings',
  },
  {
    key: 'carrySettings',
    label: 'Carry settings',
    content: <CarrySettings />,
    urlParam: 'carrySettings',
  },
  {
    key: 'equalisationInterest',
    label: 'Equalisation interest',
    content: <EqualisationInterest />,
    urlParam: 'equalisationInterest',
  },
];

const FundSetupPage: React.FC = () => {
  return (
    <Page
      tabTitle="Fund Setup"
      heading="Fund Setup"
      headingIcon={PriceCheck}
      spacing="sm"
    >
      <ErrorBoundary loader={<PageLoader />}>
        <TabsPanel useTabsUrls fullHeight tabs={tabs} />
      </ErrorBoundary>
    </Page>
  );
};

export default FundSetupPage;
